import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Typography, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

interface LoadingFooterProps {}

export const LoadingFooter: React.FC<LoadingFooterProps> = () => {
  return (
    <VStack
      space={Spacing['inset.nano']}
      borderRadius={BoxRadius.sm}
      bg={Color.background}
      px={Spacing['inline.xxs']}
      py={Spacing['inline.xxxs']}
      alignItems="center">
      <HStack alignItems="center" justifyContent="space-between" w="full">
        <VStack space={Spacing['inline.quarck']} w="100px">
          <Skeleton
            w="full"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="full"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <VStack space={Spacing['inline.quarck']} w="100px">
          <Skeleton
            w="full"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="full"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <VStack space={Spacing['inline.quarck']} w="100px">
          <Skeleton
            w="full"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="full"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
      </HStack>
    </VStack>
  );
};
